import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'react-hot-toast';
import configureStore from './redux/configureStore';
import { persistStore } from 'redux-persist';
import { ChakraProvider } from '@chakra-ui/react';
import { extendTheme } from '@chakra-ui/react';

// 2. Update the breakpoints as key-value pairs
const breakpoints = {
    sm: '320px',
    md: '768px',
    lg: '1024px',
    xl: '1440px',
    //   '2xl': '1536px',
};

const FixIOSZoom = () => {
    useEffect(() => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        if (isIOS) {
            let viewportMeta = document.querySelector('meta[name="viewport"]');

            if (!viewportMeta) {
                viewportMeta = document.createElement('meta');
                viewportMeta.name = 'viewport';
                document.head.appendChild(viewportMeta);
            }

            viewportMeta.content =
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';

            const handleTouchStart = (e) => {
                if (
                    e.target.tagName === 'INPUT' ||
                    e.target.tagName === 'TEXTAREA' ||
                    e.target.isContentEditable
                ) {
                    document.activeElement?.scrollIntoViewIfNeeded?.();
                }
            };

            document.addEventListener('touchstart', handleTouchStart, { passive: false });

            return () => {
                document.removeEventListener('touchstart', handleTouchStart);
            };
        }
    }, []);

    return null;
};

const store = configureStore();
const persistor = persistStore(store);
const theme = extendTheme({ breakpoints });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ChakraProvider theme={theme}>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <FixIOSZoom />
                    <App />
                </PersistGate>
                <Toaster />
            </Provider>{' '}
        </ChakraProvider>
    </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
